import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Users, Truck, DollarSign } from "lucide-react";

const revenueData = [
  { name: "Street Sales", value: 75 },
  { name: "Catering & Events", value: 20 },
  { name: "Merchandise", value: 5 },
];

const COLORS = ["#4F46E5", "#16A34A", "#F59E0B"];

export default function CompanyInsights() {
  return (
    <div className="bg-white p-6 shadow rounded-lg mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h2 className="text-lg font-medium text-gray-900 mb-2">📊 Company Insights</h2>
          <p className="mt-2 text-gray-700"><Truck className="inline-block h-6 w-6 text-blue-600 mr-2" /><strong>Legal Structure:</strong> LLC</p>
          <p className="mt-2 text-gray-700"><DollarSign className="inline-block h-6 w-6 text-green-600 mr-2" /><strong>Business Model:</strong> Food truck operations & catering services</p>
          <p className="mt-2 text-gray-700"><Truck className="inline-block h-6 w-6 text-purple-600 mr-2" /><strong>Number of Food Trucks:</strong> 5</p>
          <p className="mt-2 text-gray-700"><Users className="inline-block h-6 w-6 text-orange-600 mr-2" /><strong>Customer Base:</strong> Local professionals, college students, event organizers</p>
          <div className="mt-3 text-sm text-gray-500">
            <ul className="list-disc pl-5">
              <li><strong>Street Sales (75%):</strong> Primary source of revenue driven by daily operations and high customer footfall.</li>
              <li><strong>Catering & Events (20%):</strong> Profitable due to larger order sizes and predictable income streams.</li>
              <li><strong>Merchandise (5%):</strong> Incremental revenue through branded items sold to loyal customers.</li>
            </ul>
          </div>
          <div className="mt-3 text-sm text-gray-500">
            The company's diversified revenue streams provide resilience against seasonal fluctuations and changing consumer preferences.
          </div>
        </div>
        <div className="flex justify-center items-center">
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={revenueData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {revenueData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
